import EventEmitter from "events";


const channels = {};


export class BroadcastAndLocalChannel {
    private readonly channel: BroadcastChannel;
    private readonly emitter: EventEmitter;

    constructor(name: string) {
        const exists = channels[name];
        if (exists) {
            return exists;
        }
        this.channel = new BroadcastChannel(name);
        this.emitter = new EventEmitter();
    }

    postMessage(message) {
        this.channel.postMessage(message);
        this.emitter.emit("message", message);
    }

    addEventListener(type: keyof BroadcastChannelEventMap, listener: (message: any) => any) {
        this.emitter.addListener(type, listener);
        this.channel.addEventListener(type, listener);
    }

    removeEventListener(type: keyof BroadcastChannelEventMap, listener: (message: any) => any) {
        this.emitter.removeListener(type, listener);
        this.channel.removeEventListener(type, listener);
    }

    close() {
        this.channel.close()
        this.emitter.removeAllListeners();
    }
}